import useNudgeStore from '../stores/useNudgeStore';

/**
 * In-app re-engagement banner (Channel 2 of shared-docs/re-engagement-nudges.md).
 *
 * Rendered from the launch-time /sessions response when a fresh inAppNudge is
 * present and not yet dismissed on this device. Styled in the app's branded
 * toast/design language: sky accent border, soft shadow, rounded card, close
 * button. One banner max; never blocks the UI.
 */
export default function NudgeBanner() {
  const nudge = useNudgeStore((s) => s.nudge);
  const dismiss = useNudgeStore((s) => s.dismiss);

  if (!nudge) return null;

  return (
    <div className="mx-auto max-w-2xl px-4 pt-3">
      <div
        role="status"
        className="relative flex items-start gap-3 rounded-2xl border-l-4 border-sky-500 bg-white p-4 shadow-[0_8px_30px_rgba(0,0,0,0.10),0_2px_8px_rgba(0,0,0,0.06)] ring-1 ring-gray-100 dark:border-sky-400 dark:bg-night-surface dark:ring-night-card"
      >
        <span aria-hidden="true" className="mt-0.5 text-2xl leading-none">
          🏔️
        </span>
        <div className="min-w-0 flex-1 pr-6">
          {nudge.title && (
            <p className="text-sm font-semibold text-gray-900 dark:text-night-text">
              {nudge.title}
            </p>
          )}
          {nudge.body && (
            <p className="mt-0.5 text-sm leading-snug text-gray-600 dark:text-night-muted">
              {nudge.body}
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-night-card dark:hover:text-night-text"
        >
          <span aria-hidden="true" className="text-base leading-none">
            ✕
          </span>
        </button>
      </div>
    </div>
  );
}
